/**
 * Human-readable labels for audit log action and entity type values.
 *
 * Keep in sync with internal/auth/actions.go.
 * When a new Action or EntityType constant lands there, add the label here.
 * ACTION_OPTIONS / ENTITY_TYPE_OPTIONS are derived automatically.
 */

export const ACTION_LABELS: Record<string, string> = {
  // Přihlášení
  login_success: "Přihlášení",
  login_failure: "Neúspěšné přihlášení",
  logout: "Odhlášení",
  password_change: "Změna hesla",

  // Uživatelé
  user_created: "Uživatel vytvořen",
  user_updated: "Uživatel upraven",
  user_deleted: "Uživatel smazán",

  // Firmy
  company_created: "Firma vytvořena",
  company_updated: "Firma upravena",
  company_member_set: "Nastavena role ve firmě",
  company_member_removed: "Odebrán člen firmy",

  // Kontakty
  contact_created: "Kontakt vytvořen",
  contact_updated: "Kontakt upraven",
  contact_deleted: "Kontakt smazán",

  // Produkty
  product_created: "Produkt vytvořen",
  product_updated: "Produkt upraven",
  product_deleted: "Produkt smazán",

  // Číselné řady
  number_series_created: "Číselná řada vytvořena",
  number_series_updated: "Číselná řada upravena",
  number_series_deleted: "Číselná řada smazána",

  // Doklady
  document_created: "Doklad vytvořen",
  document_updated: "Doklad upraven",
  document_deleted: "Koncept dokladu smazán",
  document_issued: "Doklad vystaven",

  // Údržba
  audit_pruned: "Promazání auditního logu",
  legacy_imported: "Import ze staré aplikace",
};

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  user: "Uživatel",
  company: "Firma",
  contact: "Kontakt",
  product: "Produkt",
  number_series: "Číselná řada",
  document: "Doklad",
};

export const ACTION_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Vše" },
  ...Object.entries(ACTION_LABELS)
    .sort((a, b) => a[1].localeCompare(b[1], "cs"))
    .map(([value, label]) => ({ value, label })),
];

export const ENTITY_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Vše" },
  ...Object.entries(ENTITY_TYPE_LABELS)
    .sort((a, b) => a[1].localeCompare(b[1], "cs"))
    .map(([value, label]) => ({ value, label })),
];

export function labelAction(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function labelEntityType(entityType: string): string {
  return ENTITY_TYPE_LABELS[entityType] ?? entityType;
}
